import React from 'react';
import {
    doughnutFusionChartManager,
    dualYCombination,
    dualLineCombination,
    horizontalLed2,
    disposeChart

} from '../../../../../util/fusionChartManager';

import {connect} from 'react-redux';

class Metrics extends React.Component {

    networkOpsAssurance;
    networkOpsAssuranceIn;
    networkOpsAssuranceOut;
    networkOpsAssuranceAged;
    networkOpsAssuranceMttr;
    networkOpsAssuranceRft;
    networkOpsAssuranceSla;

    leadIndicatorsId = "leadIndicators";
    csatId = "csat";
    networkEngineeringId = "networkEngineering";
    networkEngineeringInId = "networkEngineering-in";
    networkEngineeringOutId = "networkEngineering-out";
    networkEngineeringAgedId = "networkEngineering-aged";
    networkEngineeringMttrId = "networkEngineering-mttr";
    networkEngineeringRftId = "networkEngineering-rft";
    networkEngineeringSlaId = "networkEngineering-sla";

    customerConnectionsId = "customerConnections";
    customerConnectionsInId = "customerConnections-in";
    customerConnectionsOutId = "customerConnections-out";
    customerConnectionsAgedId = "customerConnections-aged";
    customerConnectionsMttrId = "customerConnections-mttr";
    customerConnectionsRftId = "customerConnections-rft";
    customerConnectionsSlaId = "customerConnections-sla";

    serviceAssuranceId = "serviceAssurance";
    serviceAssuranceInId = "serviceAssurance-in";
    serviceAssuranceOutId = "serviceAssurance-out";
    serviceAssuranceAgedId = "serviceAssurance-aged";
    serviceAssuranceMttrId = "serviceAssurance-mttr";
    serviceAssuranceRftId = "serviceAssurance-rft";
    serviceAssuranceSlaId = "serviceAssurance-sla";

    networkOpsAssuranceId = "networkOpsAssurance";
    networkOpsAssuranceInId = "networkOpsAssurance-in";
    networkOpsAssuranceOutId = "networkOpsAssurance-out";
    networkOpsAssuranceAgedId = "networkOpsAssurance-aged";
    networkOpsAssuranceMttrId = "networkOpsAssurance-mttr";
    networkOpsAssuranceRftId = "networkOpsAssurance-rft";
    networkOpsAssuranceSlaId = "networkOpsAssurance-sla";

    constructor(props) {
        super(props);

        this.props.showLoader();

        this.state = {

            // Setting initial value of partial loader state for each of the charts
            // present on the page
            partialLoaderStateLeadIndicators: true,
            partialLoaderStateCustomerSatisfaction: true,
            partialLoaderStateNetworkEngineering: true,
            partialLoaderStateCustomerConnections: true,
            partialLoaderStateServiceAssurance: true,
            partialLoaderStateNetworkOpsAndAssurance: true,

            partialLoaderStateReadyForServiceIn: true,
            partialLoaderStateReadyForServiceOut: true,
            partialLoaderStateReadyForServiceAged: true,
            partialLoaderStateReadyForServiceInMTTR: true,
            partialLoaderStateReadyForServiceInRFT: true,
            partialLoaderStateReadyForServiceInSLA: true,

            partialLoaderStateNetPremisesActivatedIn: true,
            partialLoaderStateNetPremisesActivatedOut: true,
            partialLoaderStateNetPremisesActivatedAged: true,
            partialLoaderStateNetPremisesActivatedInMTTR: true,
            partialLoaderStateNetPremisesActivatedInRFT: true,
            partialLoaderStateNetPremisesActivatedInSLA: true,

            partialLoaderStateServiceIncidentsIn: true,
            partialLoaderStateServiceIncidentsOut: true,
            partialLoaderStateServiceIncidentsAged: true,
            partialLoaderStateServiceIncidentsInMTTR: true,
            partialLoaderStateServiceIncidentsInRFT: true,
            partialLoaderStateServiceIncidentsInSLA: true,

            partialLoaderStateNetworkFaultsIn: true,
            partialLoaderStateNetworkFaultsOut: true,
            partialLoaderStateNetworkFaultsAged: true,
            partialLoaderStateNetworkFaultsInMTTR: true,
            partialLoaderStateNetworkFaultsInRFT: true,
            partialLoaderStateNetworkFaultsInSLA: true,
        };
    }

    componentDidMount() {

        let self = this;
        const leadIndicatorsCategories = [
            {
                category: [
                    {
                        label: 'OTD Performance',
                    }, {
                        label: 'Right First Time',
                    }, {
                        label: 'Cost per Premise',
                    }, {
                        label: 'Forecast Accuracy',
                    }, {
                        label: 'Service Incidents',
                    }, {
                        label: 'Network Availability',
                    }, {
                        label: 'Truck Roll Cost Rate',
                    },
                ],
            },
        ];

        const leadIndicatorsDataset = [
            {
                seriesName: 'This Week',
                color: '#4fb1ec',
                data: [
                    {
                        value: '17',
                    }, {
                        value: '130',
                    }, {
                        value: '104',
                    }, {
                        value: '84',
                    }, {
                        value: '14',
                    }, {
                        value: '96',
                    }, {
                        value: '87',
                    },
                ],
            }, {
                seriesName: 'Last Week',
                parentYAxis: 'S',
                renderAs: 'line',
                showValues: '0',
                color: '#92d050',
                data: [
                    {
                        value: '17',
                    }, {
                        value: '130',
                    }, {
                        value: '104',
                    }, {
                        value: '84',
                    }, {
                        value: '14',
                    }, {
                        value: '96',
                    }, {
                        value: '87',
                    },
                ],
            },
        ];

        const csatCategories = [
            {
                category: [
                    {
                        label: '',
                    }, {
                        label: '11 Dec',
                    }, {
                        label: '12 Dec',
                    }, {
                        label: '',
                    }, {
                        label: '13 Dec',
                    }, {
                        label: '14 Dec',
                    }, {
                        label: '15 Dec',
                    },
                ],
            },
        ];

        const csatDataset = [
            {
                seriesName: 'This Week',
                color: '#4fb1ec',
                data: [
                    {
                        value: '17',
                    }, {
                        value: '130',
                    }, {
                        value: '104',
                    }, {
                        value: '84',
                    }, {
                        value: '14',
                    }, {
                        value: '96',
                    }, {
                        value: '87',
                    },
                ],
            }, {
                seriesName: 'Last Week',
                color: '#92d050',
                data: [
                    {
                        value: '84',
                    }, {
                        value: '20',
                    }, {
                        value: '104',
                    }, {
                        value: '54',
                    }, {
                        value: '84',
                    }, {
                        value: '73',
                    }, {
                        value: '25',
                    },
                ],
            },
        ];

        dualYCombination('leadIndicators', leadIndicatorsCategories, leadIndicatorsDataset)
            .then((data) => {
                self.setState({
                    partialLoaderStateLeadIndicators: false
                });
            }, () => {

            });

        dualLineCombination('csat', csatCategories, csatDataset)
            .then((data) => {
                self.setState({
                    partialLoaderStateCustomerSatisfaction: false
                });
            });

        const widthOfNetworkEngineering = $('#networkEngineering').width();

        // Col - 1 : Network engineering
        doughnutFusionChartManager('networkEngineering', '', [
            {
                label: 'Device',
                value: '15',
            }, {
                label: 'No Device',
                value: '85',
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0',
            },
        ], 'Ready for Service', widthOfNetworkEngineering / 2)
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkEngineering: false
                });
            });

        horizontalLed2('networkEngineering-in', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceIn: false
                });
            });
        horizontalLed2('networkEngineering-out', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceOut: false
                });
            });
        horizontalLed2('networkEngineering-aged', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceAged: false
                });
            })// AGED

        horizontalLed2('networkEngineering-mttr', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceInMTTR: false
                });
            });// MTTR
        horizontalLed2('networkEngineering-rft', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceInRFT: false
                });
            });// RFT
        horizontalLed2('networkEngineering-sla', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateReadyForServiceInSLA: false
                });
            });// SLA

        const widthOfCustomerConnections = $('#customerConnections').width();

        // Col - 2 : Customer connections
        doughnutFusionChartManager('customerConnections', '', [
            {
                label: 'Device',
                value: '15',
            }, {
                label: 'No Device',
                value: '85',
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0',
            },
        ], 'Net Premises Activated', widthOfCustomerConnections / 2)
            .then((data) => {
                self.setState({
                    partialLoaderStateCustomerConnections: false
                });
            });

        horizontalLed2('customerConnections-in', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedIn: false
                });
            });// IN
        horizontalLed2('customerConnections-out', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedOut: false
                });
            })// OUT
        horizontalLed2('customerConnections-aged', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedAged: false
                });
            })// AGED

        horizontalLed2('customerConnections-mttr', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInMTTR: false
                });
            })// MTTR
        horizontalLed2('customerConnections-rft', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInRFT: false
                });
            })// RFT
        horizontalLed2('customerConnections-sla', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInSLA: false
                });
            })// SLA

        const widthOfServiceAssurance = $('#serviceAssurance').width();

        // Col - 3 : Service Assurance
        doughnutFusionChartManager('serviceAssurance', '', [
            {
                label: 'Device',
                value: '15',
            }, {
                label: 'No Device',
                value: '85',
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0',
            },
        ], 'Service Incidents', widthOfServiceAssurance / 2)
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceAssurance: false
                });
            });

        horizontalLed2('serviceAssurance-in', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsIn: false
                });
            });// IN
        horizontalLed2('serviceAssurance-out', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsOut: false
                });
            });// OUT
        horizontalLed2('serviceAssurance-aged', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsAged: false
                });
            });// AGED

        horizontalLed2('serviceAssurance-mttr', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsInMTTR: false
                });
            });// MTTR
        horizontalLed2('serviceAssurance-rft', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsInRFT: false
                });
            });// RFT
        horizontalLed2('serviceAssurance-sla', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateServiceIncidentsInSLA: false
                });
            });// SLA

        const widthOfNetworkOpsAssurance = $('#networkOpsAssurance').width();

        // Col - 4 : Network Ops & Assurance
        doughnutFusionChartManager('networkOpsAssurance', '', [
            {
                label: 'Device',
                value: '15',
            }, {
                label: 'No Device',
                value: '85',
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0',
            },
        ], 'Network Faults', widthOfNetworkOpsAssurance / 2)
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkOpsAndAssurance: false
                });
            });

        horizontalLed2('networkOpsAssurance-in', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsIn: false
                });
            });// IN
        horizontalLed2('networkOpsAssurance-out', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsOut: false
                });
            });// OUT
        horizontalLed2('networkOpsAssurance-aged', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsAged: false
                });
            });// AGED

        horizontalLed2('networkOpsAssurance-mttr', ' ', ' ', ' ', '80')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsInMTTR: false
                });
            });// MTTR
        horizontalLed2('networkOpsAssurance-rft', ' ', ' ', ' ', '54')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsInRFT: false
                });
            });// RFT
        horizontalLed2('networkOpsAssurance-sla', ' ', ' ', ' ', '16')
            .then((data) => {
                self.setState({
                    partialLoaderStateNetworkFaultsInSLA: false
                });
            });// SLA
    } // End of componentDidMount function

    componentWillUnmount() {

        disposeChart(this.leadIndicatorsId);
        disposeChart(this.csatId);
        disposeChart(this.networkEngineeringId);
        disposeChart(this.networkEngineeringInId);
        disposeChart(this.networkEngineeringOutId);
        disposeChart(this.networkEngineeringAgedId);
        disposeChart(this.networkEngineeringMttrId);
        disposeChart(this.networkEngineeringRftId);
        disposeChart(this.networkEngineeringSlaId);

        disposeChart(this.customerConnectionsId);
        disposeChart(this.customerConnectionsInId);
        disposeChart(this.customerConnectionsOutId);
        disposeChart(this.customerConnectionsAgedId);
        disposeChart(this.customerConnectionsMttrId);
        disposeChart(this.customerConnectionsRftId);
        disposeChart(this.customerConnectionsSlaId);

        disposeChart(this.serviceAssuranceId);
        disposeChart(this.serviceAssuranceInId);
        disposeChart(this.serviceAssuranceOutId);
        disposeChart(this.serviceAssuranceAgedId);
        disposeChart(this.serviceAssuranceMttrId);
        disposeChart(this.serviceAssuranceRftId);
        disposeChart(this.serviceAssuranceSlaId);

        disposeChart(this.networkOpsAssuranceId);
        disposeChart(this.networkOpsAssuranceInId);
        disposeChart(this.networkOpsAssuranceOutId);
        disposeChart(this.networkOpsAssuranceAgedId);
        disposeChart(this.networkOpsAssuranceMttrId);
        disposeChart(this.networkOpsAssuranceRftId);
        disposeChart(this.networkOpsAssuranceSlaId);


    }

    dispatchActionToHideLoader = () => {

        if(!this.state.partialLoaderStateLeadIndicators
            &&!this.state.partialLoaderStateCustomerSatisfaction
            &&!this.state.partialLoaderStateNetworkEngineering
            &&!this.state.partialLoaderStateCustomerConnections
            &&!this.state.partialLoaderStateServiceAssurance
            &&!this.state.partialLoaderStateNetworkOpsAndAssurance

            &&!this.state.partialLoaderStateReadyForServiceIn
            &&!this.state.partialLoaderStateReadyForServiceOut
            &&!this.state.partialLoaderStateReadyForServiceAged
            &&!this.state.partialLoaderStateReadyForServiceInMTTR
            &&!this.state.partialLoaderStateReadyForServiceInRFT
            &&!this.state.partialLoaderStateReadyForServiceInSLA

            &&!this.state.partialLoaderStateNetPremisesActivatedIn
            &&!this.state.partialLoaderStateNetPremisesActivatedOut
            &&!this.state.partialLoaderStateNetPremisesActivatedAged
            &&!this.state.partialLoaderStateNetPremisesActivatedInMTTR
            &&!this.state.partialLoaderStateNetPremisesActivatedInRFT
            &&!this.state.partialLoaderStateNetPremisesActivatedInSLA

            &&!this.state.partialLoaderStateServiceIncidentsIn
            &&!this.state.partialLoaderStateServiceIncidentsOut
            &&!this.state.partialLoaderStateServiceIncidentsAged
            &&!this.state.partialLoaderStateServiceIncidentsInMTTR
            &&!this.state.partialLoaderStateServiceIncidentsInRFT
            &&!this.state.partialLoaderStateServiceIncidentsInSLA

            &&!this.state.partialLoaderStateNetworkFaultsIn
            &&!this.state.partialLoaderStateNetworkFaultsOut
            &&!this.state.partialLoaderStateNetworkFaultsAged
            &&!this.state.partialLoaderStateNetworkFaultsInMTTR
            &&!this.state.partialLoaderStateNetworkFaultsInRFT
            &&!this.state.partialLoaderStateNetworkFaultsInSLA) {
            this.props.hideLoader();
        }

    };

    render() {

        this.dispatchActionToHideLoader();

        return (<div className="row" id="metrics">
            <div className="col-12">
                <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h1 className="mb-0">Metrics</h1>
                </div>
            </div>
            {/**/}

            <div className="col-12">
                <div className="row">
                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12"> */}
                    {/* <div className="row"> */}
                    <div className="col-lg-9">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-6">
                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-2">
                                        <h3 className="card-heading d-inline-block">
                                            Lead Indicators
                                        </h3>
                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.leadIndicatorsId}/>

                                    </div>

                                </div>

                            </div>
                            <div className="col-12 col-sm-6 col-lg-6">
                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-2">
                                        <h3 className="card-heading d-inline-block">
                                            Customer Satisfaction (CSAT)
                                        </h3>
                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.csatId}/>

                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-lg-3">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-3">
                                        <h3 className="card-heading d-inline-block">
                                            Network Engineering
                                        </h3>
                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.networkEngineeringId}/>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Volume:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 float-left label-min-width">IN</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringInId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />2%
                                                </div>

                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">OUT</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringOutId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />4%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">AGED</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringAgedId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2"><i
                                                    className="fa fa fa-long-arrow-down mt-1"
                                                    style={{
                                                        color: 'green',
                                                    }}
                                                    aria-hidden="true"
                                                />3%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center text-nowrap">Key Metrics:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">MTTR</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringMttrId}/>
                                                <div className="col-1 pt-2 text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{color: 'red'}}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">RFT</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringRftId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">SLA</div>
                                                <div className="col-8 px-1" id={this.networkEngineeringSlaId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2"><i
                                                    className="fa fa fa-long-arrow-down mt-1"
                                                    style={{
                                                        color: 'green',
                                                    }}
                                                    aria-hidden="true"
                                                />7%
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div className="col-sm-6 col-lg-3">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-3">
                                        <h3 className="card-heading d-inline-block">
                                            Customer Connections
                                        </h3>
                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.customerConnectionsId}/>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Volume:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">IN</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsInId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />2%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">OUT</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsOutId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />4%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">AGED</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsAgedId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />3%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Key Metrics::
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">MTTR</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsMttrId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">RFT</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsRftId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">SLA</div>
                                                <div className="col-8 px-1" id={this.customerConnectionsSlaId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />7%
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="col-sm-6 col-lg-3">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-3">
                                        <h3 className="card-heading d-inline-block">
                                            Service Assurance
                                        </h3>

                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.serviceAssuranceId}/>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Volume:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">IN</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceInId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />2%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">OUT</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceOutId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />4%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">AGED</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceAgedId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />3%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Key Metrics::
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">MTTR</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceMttrId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">RFT</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceRftId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">SLA</div>
                                                <div className="col-8 px-1" id={this.serviceAssuranceSlaId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />7%
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="col-sm-6 col-lg-3">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-3">
                                        <h3 className="card-heading d-inline-block ">
                                            Network Ops & Assurance
                                        </h3>

                                    </div>
                                    <div className="jr-card-body ">
                                        {/**/}
                                        <div id={this.networkOpsAssuranceId}/>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Volume:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">IN</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceInId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />2%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">OUT</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceOutId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />4%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">AGED</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceAgedId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />3%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex text-heading ma-font">
                                            <div className="col-6 text-left align-self-center">Key Metrics:
                                            </div>
                                            <div className="col-6 text-center align-self-center text-nowrap">Trend <br/>(Last
                                                Week):
                                            </div>
                                        </div>
                                        <div className="horizontalBarWrapper p-2 ma-font">
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">MTTR</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceMttrId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">RFT</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceRftId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-up mt-1"
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                        aria-hidden="true"
                                                    />1%
                                                </div>
                                            </div>
                                            <div className="col-12 p-0 inline">
                                                <div className="col-3 px-0 pt-2 label-min-width">SLA</div>
                                                <div className="col-8 px-1" id={this.networkOpsAssuranceSlaId}/>
                                                <div className="col-1 text-right text-nowrap px-0 pt-2">
                                                    <i
                                                        className="fa fa fa-long-arrow-down mt-1"
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                        aria-hidden="true"
                                                    />7%
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="row">
                            <div className="col-12">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-2">
                                        <h3 className="card-heading d-inline-block">
                                            Finance
                                        </h3>

                                    </div>
                                    <div className="jr-card-body set-background ">
                                        {/**/}
                                        <div id="finance"/>
                                        <div className="col-12">
                                            <div className="finance-section d-inline-flex w-100">
                                                <div className="col left-text w-50 float-left px-0">
                                                    <h5 className="t-cost">
                                                        <sup className="dollar">$</sup>67<sub
                                                        className="cost-suffix">m</sub>
                                                    </h5>
                                                </div>
                                                <div className="col text-right w-50 float-right px-0">
                                                    <img src="../../../../../assets/images/finance.png" alt=""/>
                                                </div>
                                            </div>
                                            <p className="t-blue">Capital Expenditure
                                                <br/>
                                                <span>(Last month)</span>
                                            </p>
                                            <div className="text-options li-font">
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">Capital Expenditure
                                                        (YTD)
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">$ XXXm</li>
                                                </ul>
                                                <br/>
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">Capital Expenditure
                                                        (Budget)
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">$ XXXm</li>
                                                </ul>
                                                <br/>
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">Total Operating
                                                        Expenses
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">$ XXXm</li>
                                                </ul>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 ">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-2">
                                        <h3 className="card-heading d-inline-block">
                                            HSE
                                        </h3>

                                    </div>
                                    <div className="jr-card-body set-background ">
                                        {/**/}
                                        <div id="hse"/>
                                        <div className="col-12">
                                            <div className="finance-section d-inline-flex w-100">
                                                <div className="col left-text w-50 float-left px-0">
                                                    <h5 className="t-cost">72</h5>
                                                </div>
                                                <div className="col text-right w-50 float-right px-0">
                                                    <img src="../../../../../assets/images/hse.png" alt=""/>
                                                </div>
                                            </div>
                                            <p className="t-blue">Total Recordable Injuries<br/>
                                                <span>(Last month)</span>
                                            </p>
                                            <div className="text-options li-font">
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">High Potential Injury
                                                        Freq. Rate.
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">XXX</li>
                                                </ul>
                                                <br/>
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">Workforce Headcount
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">XXX</li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="row">
                            <div className="col-12">

                                <div className="jr-card jr-card-sb">
                                    <div className="jr-card-header px-2">
                                        <h3 className="card-heading d-inline-block">
                                            Security
                                        </h3>

                                    </div>
                                    <div className="jr-card-body set-background ">
                                        {/**/}
                                        <div id="security"/>
                                        <div className="col-12">
                                            <div className="finance-section d-inline-flex w-100">
                                                <div className="col left-text w-50 float-left px-0">
                                                    <h5 className="t-cost">14</h5>
                                                </div>
                                                <div className="col text-right w-50 float-right px-0">
                                                    <img src="../../../../../assets/images/security.png"/>
                                                </div>
                                            </div>
                                            <p className="t-blue">Security Breaches
                                                <br/>
                                                <span>(Last month)</span>
                                            </p>
                                            <div className="text-options li-font">
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline"># of High Security Site
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">XXX</li>
                                                </ul>
                                                <br/>
                                                <ul className="list-inline">
                                                    <li className="text-underline left inline">High Potential Security
                                                        Risk.
                                                    </li>
                                                    <li className="text-underline text-nowrap right inline">XXX</li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <button className="metric-export pt-2 pb-2">Export Reports</button>
                            </div>
                        </div>

                    </div>
                    {/* </div> */}
                    {/* </div> */}

                </div>

            </div>

            {/**/}

        </div>);
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => {
            dispatch({type: 'SHOW_OVERALL_APP_LOADER'});
        },
        hideLoader: () => {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    }
};

export default connect(null, mapDispatchToProps)(Metrics);



// WEBPACK FOOTER //
// ./app/routes/components/routes/metrics/index.js